module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAADCAYAAABlE6q2AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAAeSURBVDiNY2RgYPjPMAoGDWAaaAeMAlQwGiGDDAAAvVkBBWRl1+EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/Line 17.png
// module id = dfl5
// module chunks = 8